


// import React, { useState } from 'react';
// import {
//   AppBar, Toolbar, Typography, IconButton,
//   Drawer, List, ListItem, ListItemIcon, ListItemText, CssBaseline, Box, Menu, MenuItem, Tooltip
// } from '@mui/material';
// import {
//   Menu as MenuIcon, AccountCircle, Person, ShoppingCart, Gavel
// } from '@mui/icons-material';
// import { useNavigate, Outlet } from 'react-router-dom';

// const drawerWidthExpanded = 240;
// const drawerWidthCollapsed = 72;

// const DashboardLayout = () => {
//   const navigate = useNavigate();
//   const [drawerOpen, setDrawerOpen] = useState(true);
//   const [anchorEl, setAnchorEl] = useState(null);

//   const user = JSON.parse(sessionStorage.getItem('user') || '{}');
//   const role = user.role || 'Unknown';

//   const toggleDrawer = () => setDrawerOpen(!drawerOpen);
//   const handleMenuClick = (e) => setAnchorEl(e.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);
//   const logout = () => {
//     localStorage.removeItem('token');
//     sessionStorage.clear();
//     navigate('/');
//   };

//   const menuItems = [
//     { label: 'Profile', path: '/profile', icon: <Person /> },
//     { label: 'Products', path: '/products', icon: <ShoppingCart /> },
//     { label: 'Bids', path: '/bids', icon: <Gavel /> },
//   ];

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar position="fixed" sx={{ backgroundColor: '#952929', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
//         <Toolbar>
//           <IconButton color="inherit" edge="start" onClick={toggleDrawer} sx={{ mr: 2 }}>
//             <MenuIcon />
//           </IconButton>
//           <img src="/logo.png" alt="Logo" style={{ height: 40, marginRight: 10 }} />
//           <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
//             Dashboard - {role.charAt(0).toUpperCase() + role.slice(1)}
//           </Typography>
//           <IconButton color="inherit" onClick={handleMenuClick}>
//             <AccountCircle />
//           </IconButton>
//           <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//             <MenuItem onClick={logout}>Logout</MenuItem>
//           </Menu>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar Drawer */}
//       <Drawer
//         variant="permanent"
//         sx={{
//           width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
//           flexShrink: 0,
//           '& .MuiDrawer-paper': {
//             width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
//             backgroundColor: '#952929',
//             color: '#fff',
//             transition: 'width 0.3s',
//             overflowX: 'hidden',
//           },
//         }}
//       >
//         <Toolbar />
//         <List>
//           {menuItems.map((item) => (
//             <Tooltip key={item.label} title={!drawerOpen ? item.label : ''} placement="right">
//               <ListItem
//                 button
//                 onClick={() => navigate(item.path)}
//                 sx={{
//                   color: '#fff',
//                   '&:hover': {
//                     backgroundColor: '#7a1e1e',
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ color: '#fff', minWidth: 0, mr: drawerOpen ? 2 : 'auto', justifyContent: 'center' }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 {drawerOpen && <ListItemText primary={item.label} />}
//               </ListItem>
//             </Tooltip>
//           ))}
//         </List>
//       </Drawer>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           mt: 8,
//           width: `calc(100% - ${drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed}px)`,
//           transition: 'width 0.3s',
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// };

// export default DashboardLayout;


// import React, { useState } from 'react';
// import {
//   AppBar, Toolbar, Typography, IconButton, Drawer,
//   List, ListItem, ListItemIcon, ListItemText, CssBaseline,
//   Box, Menu, MenuItem, Tooltip, useMediaQuery, useTheme
// } from '@mui/material';
// import {
//   Menu as MenuIcon, AccountCircle, Person, ShoppingCart, Gavel
// } from '@mui/icons-material';
// import { useNavigate, Outlet } from 'react-router-dom';
// import vyaparlogo from '../Images/vyaparlogo.png';


// const drawerWidthExpanded = 240;
// const drawerWidthCollapsed = 72;

// const DashboardLayout = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const [drawerOpen, setDrawerOpen] = useState(!isMobile); // auto-close on mobile
//   const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false); // separate control
//   const [anchorEl, setAnchorEl] = useState(null);

//   const user = JSON.parse(sessionStorage.getItem('user') || '{}');
//   const role = user.role || 'Unknown';

//   const toggleDrawer = () => {
//     if (isMobile) {
//       setMobileDrawerOpen(!mobileDrawerOpen);
//     } else {
//       setDrawerOpen(!drawerOpen);
//     }
//   };

//   const handleMenuClick = (e) => setAnchorEl(e.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);

//   const logout = () => {
//     localStorage.removeItem('token');
//     sessionStorage.clear();
//     navigate('/login');
//   };

//   const menuItems = [
//     { label: 'Profile', path: '/profile', icon: <Person /> },
//     { label: 'Products', path: '/products', icon: <ShoppingCart /> },
//     { label: 'Bids', path: '/bids', icon: <Gavel /> },
//   ];

//   const renderDrawerContent = (
//     <Box role="presentation" onClick={isMobile ? toggleDrawer : undefined}>
//       <Toolbar />
//       <List>
//         {menuItems.map((item) => (
//           <Tooltip key={item.label} title={!drawerOpen && !isMobile ? item.label : ''} placement="right">
//             <ListItem
//               button
//               onClick={() => navigate(item.path)}
//               sx={{
//                 color: '#fff',
//                 '&:hover': {
//                   backgroundColor: '#7a1e1e',
//                 },
//               }}
//             >
//               <ListItemIcon sx={{ color: '#fff', minWidth: 0, mr: drawerOpen || isMobile ? 2 : 'auto', justifyContent: 'center' }}>
//                 {item.icon}
//               </ListItemIcon>
//               {(drawerOpen || isMobile) && <ListItemText primary={item.label} />}
//             </ListItem>
//           </Tooltip>
//         ))}
//       </List>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <CssBaseline />

//       {/* App Bar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           backgroundColor: '#952929',
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//       >
//         <Toolbar>
//           <IconButton color="inherit" edge="start" onClick={toggleDrawer} sx={{ mr: 2 }}>
//             <MenuIcon />
//           </IconButton>
//           <img src={vyaparlogo} alt="Logo" style={{ height: 40, marginRight: 10 }} />
//           <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
//             Dashboard - {role.charAt(0).toUpperCase() + role.slice(1)}
//           </Typography>
//           <IconButton color="inherit" onClick={handleMenuClick}>
//             <AccountCircle />
//           </IconButton>
//           <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//             <MenuItem onClick={logout}>Logout</MenuItem>
//           </Menu>
//         </Toolbar>
//       </AppBar>

//       {/* Drawer */}
//       {isMobile ? (
//         <Drawer
//           variant="temporary"
//           open={mobileDrawerOpen}
//           onClose={toggleDrawer}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             '& .MuiDrawer-paper': {
//               width: drawerWidthExpanded,
//               backgroundColor: '#952929',
//               color: '#fff',
//               zIndex: theme.zIndex.drawer + 2,
//             },
//           }}
//         >
//           {renderDrawerContent}
//         </Drawer>
//       ) : (
//         <Drawer
//           variant="permanent"
//           sx={{
//             width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
//             flexShrink: 0,
//             '& .MuiDrawer-paper': {
//               width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
//               backgroundColor: '#952929',
//               color: '#fff',
//               transition: 'width 0.3s',
//               overflowX: 'hidden',
//             },
//           }}
//         >
//           {renderDrawerContent}
//         </Drawer>
//       )}

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           mt: 8,
//           width: `calc(100% - ${
//             isMobile ? '0px' : drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed
//           })`,
//           transition: 'width 0.3s',
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// };

// export default DashboardLayout;

import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Drawer,
  List, ListItem, ListItemIcon, ListItemText, CssBaseline,
  Box, Menu, MenuItem, Tooltip, useMediaQuery, useTheme
} from '@mui/material';
import {
  Menu as MenuIcon, AccountCircle, Person, ShoppingCart, Gavel,  ExpandLess, ExpandMore ,

  AssignmentTurnedIn,
  Schedule,
  Cancel,
  AddCircle,
  CheckCircle,
  DoneAll,
} from '@mui/icons-material';
import Collapse from '@mui/material/Collapse';

import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { Home, Favorite, Dashboard, Group, Assessment } from '@mui/icons-material';

import vyaparlogo from '../Images/vyaparlogo.png';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';




const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 72;

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

const [openSubmenus, setOpenSubmenus] = useState({});

const handleSubmenuToggle = (label) => {
  setOpenSubmenus((prev) => ({
    ...prev,
    [label]: !prev[label],
  }));
};

  const [drawerOpen, setDrawerOpen] = useState(!isMobile);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const user = JSON.parse(sessionStorage.getItem('user') || '{}');
  const role = user.role || 'Unknown';

  const toggleDrawer = () => {
    if (isMobile) {
      setMobileDrawerOpen(!mobileDrawerOpen);
    } else {
      setDrawerOpen(!drawerOpen);
    }
  };

  const handleMenuClick = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const logout = () => {
    localStorage.removeItem('token');
    sessionStorage.clear();
    navigate('/login');
  };

const menuConfig = {
  seller: [
    { label: 'Dashboard', path: '/seller-dashboard', icon: <Dashboard /> },
    { label: 'Profile', path: '/profile', icon: <Person /> },
    { label: 'Products', path: '/products', icon: <ShoppingCart /> },
    {
      label: 'Bids',
      icon: <Gavel />,
      children: [
        {
          label: 'Live Bids',
          path: '/bids/received',
          icon: <AssignmentTurnedIn />,
        },
        {
          label: 'Bids Status',
          path: '/bids/status',
          icon: <CheckCircle />,
        },
         {
          label: 'Successful Bids',
          path: '/seller-bids/success',
          icon: <DoneAll />,
        },
        {
          label: 'Expired Bids',
          path: '/seller/bids/expired',
          icon: <Cancel />,
        },
      ],
    },
  ],
  buyer: [
        { label: 'Dashboard', path: '/buyer-dashboard', icon: <Dashboard /> },
    { label: 'Profile', path: '/buyer-profile', icon: <Person /> },
    {
      label: 'My Bids',
      icon: <ShoppingCart />,
      children: [
        {
          label: 'Create Bid',
          path: '/my-bids/create',
          icon: <AddCircle />,
        },
        {
          label: 'Confirm Bid',
          path: '/my-bids/confirm',
          icon: <AssignmentTurnedIn />,
        },
        {
          label: 'Successful Bids',
          path: '/my-bids/success',
          icon: <DoneAll />,
        },
      ],
    },
  ],
  admin: [
    { label: 'Dashboard', path: '/admin-dashboard', icon: <Dashboard /> },
    { label: 'Products', path: '/admin-products', icon: <ShoppingCart /> },
    { label: 'Manage Users', path: '/users', icon: <Group /> },
    {
      label: 'Reports',
      icon: <Assessment />,
      children: [
        { label: 'Users', path: '/reports/users', icon: <Group /> },
        { label: 'Products', path: '/reports/products', icon: <ShoppingCart /> },
        { label: 'Bids', path: '/reports/bids', icon: <Gavel /> },
      ],
    },
  ],
};


const menuItems = menuConfig[role.toLowerCase()] || [];
  const renderDrawerContent = (
    <Box role="presentation" onClick={isMobile ? toggleDrawer : undefined}>
      <Toolbar />
<List>
{menuItems.map((item) => {
  const isActive = location.pathname === item.path;
  const isSubmenuOpen = openSubmenus[item.label] || false;

  return (
    <Box key={item.label}>
      <Tooltip title={!drawerOpen && !isMobile ? item.label : ''} placement="right">
        <ListItem
          button
          onClick={() => item.children ? handleSubmenuToggle(item.label) : navigate(item.path)}
          sx={{
            color: '#fff',
            backgroundColor: isActive ? '#062d59' : 'transparent',
            '&:hover': { backgroundColor: '#104E8B' },
            borderRadius: 1,
            mx: 1,
            my: 0.5,
            transition: 'background-color 0.3s ease',
          }}
        >
          <ListItemIcon
            sx={{
              color: '#fff',
              minWidth: 0,
              mr: drawerOpen || isMobile ? 2 : 'auto',
              justifyContent: 'center',
            }}
          >
            {item.icon}
          </ListItemIcon>

          {(drawerOpen || isMobile) && (
            <>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontWeight: isActive ? 'bold' : 'normal',
                  fontSize: '1rem',
                }}
              />
              {item.children && (isSubmenuOpen ? <ExpandLess /> : <ExpandMore />)}
            </>
          )}
        </ListItem>
      </Tooltip>

      {/* Submenu */}
{item.children && (
  <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: 2,
        mx: 1,
        my: 1,
        boxShadow: 2,
        overflow: 'hidden',
      }}
    >
      <List component="div" disablePadding>
        {item.children.map((subItem) => {
          const isSubActive = location.pathname === subItem.path;
          return (
            <ListItem
              key={subItem.label}
              button
              onClick={() => navigate(subItem.path)}
              sx={{
                pl: drawerOpen || isMobile ? 7 : 0,  // no left padding if drawer closed
                justifyContent: drawerOpen || isMobile ? 'flex-start' : 'center', // center if drawer closed
                backgroundColor: isSubActive ? '#e3f2fd' : 'transparent',
                color: '#062d59',
                '&:hover': {
                  backgroundColor: '#104E8B',
                  color: '#fff',
                  '& .MuiListItemIcon-root': {
                    color: '#fff', // icon color on hover
                  },
                },
                transition: 'background-color 0.3s ease',
              }}
            >
              <ListItemIcon
                sx={{
                  color: '#062d59',
                  minWidth: drawerOpen || isMobile ? 32 : 'auto', // no fixed width if drawer closed
                  justifyContent: 'center', // center icon
                }}
              >
                {subItem.icon ?? <ChevronRightIcon />}
              </ListItemIcon>
              {(drawerOpen || isMobile) && (
                <ListItemText
                  primary={subItem.label}
                  primaryTypographyProps={{
                    fontWeight: isSubActive ? 'bold' : 'normal',
                    fontSize: '0.95rem',
                  }}
                />
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  </Collapse>
)}


    </Box>
  );
})}


</List>


    </Box>
  );

  return (
    <Box sx={{ display: 'flex', backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      <CssBaseline />

{/* App Bar */}
<AppBar
  position="fixed"
  elevation={6}
  sx={{
    background: `linear-gradient(to right, #062d59, #e3080c)`,
    zIndex: (theme) => theme.zIndex.drawer + 1,
    padding: '0 16px',
  }}
>
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    
    {/* Left side: Menu button and logo */}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton color="inherit" edge="start" onClick={toggleDrawer} sx={{ mr: 1 }}>
        <MenuIcon />
      </IconButton>
<Box
  component="img"
  src={vyaparlogo}
  alt="Logo"
  sx={{
    height: 45,
    ml: drawerOpen ? `${drawerWidthExpanded - 56}px` : `${drawerWidthCollapsed - 45}px`, // reduced margin
    p: '4px 8px',
    backgroundColor: '#fff',
    borderRadius: 1,
    boxShadow: '0 0 6px rgba(0,0,0,0.15)',
    transition: 'margin-left 0.3s ease-in-out',
  }}
/>


    </Box>

    {/* Center: Title */}
    <Typography
      variant="h6"
      noWrap
      sx={{
        flexGrow: 1,
        fontWeight: 700,
        color: '#fff',
        textAlign: 'center',
      }}
    >
       {role.charAt(0).toUpperCase() + role.slice(1)}
    </Typography>

    {/* Right side: User Icon */}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title="Account Settings">
        <IconButton color="inherit" onClick={handleMenuClick}>
          <AccountCircle sx={{ fontSize: 30 }} />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </Box>
  </Toolbar>
</AppBar>


      {/* Drawer */}
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileDrawerOpen}
          onClose={toggleDrawer}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidthExpanded,
              backgroundColor: '#062d59',
              color: '#fff',
              zIndex: theme.zIndex.drawer + 2,
            },
          }}
        >
          {renderDrawerContent}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          sx={{
            width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed,
              backgroundColor: '#062d59',
              color: '#fff',
              transition: 'width 0.3s',
              overflowX: 'hidden',
              borderRight: 'none',
              boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
            },
          }}
        >
          {renderDrawerContent}
        </Drawer>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: 8,
          transition: 'width 0.3s',
          width: `calc(100% - ${
            isMobile ? '0px' : drawerOpen ? drawerWidthExpanded : drawerWidthCollapsed
          })`,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default DashboardLayout;
